import React from "react";
import { RCCGrid } from "react-common-components";
import Photo from "src/components/Photo";
import DivFlexDirectionColumn from "./styles";

const colUser: React.FC = (row: any) => {
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	return (<>
		<RCCGrid container item alignItems="center">
			<Photo 
				width={28}
				height={28}
				hover={false}
				name={row.efa005Nome||""}
				link={row.efa005Imagem && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${row.efa005Imagem}`}
			/> 
			<DivFlexDirectionColumn>
				<span>{row.efa005Nome}</span>
				<small>{row.efa005Email}</small>
			</DivFlexDirectionColumn>
		</RCCGrid>
	</>);
};

export default colUser;
